import { VCPM } from '../models/project.model';

/**
 * Input-side stretched check across every cluster of a workload. HCI workloads keep the flag on
 * `clusterConfiguration`; dHCI workloads keep it on the compute (CON) / storage (SON) mirrors, so
 * the unused HCI group's default must not be read for dHCI (and vice versa).
 *
 * Leaf module (models only) so both the request adapter and the output transforms can import it
 * without an import cycle.
 */
export function isWorkloadStretchedByInput(workload: VCPM.Workload | undefined): boolean {
  if (!workload) {
    return false;
  }
  if (workload.vcfDeploymentInputs?.deploymentType === 'dHCI') {
    return workload.computeClusterConfiguration?.clusterType === 'stretched' || workload.storageClusterConfiguration?.clusterType === 'stretched';
  }
  return workload.clusterConfiguration?.clusterType === 'stretched';
}
